// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ziWW","questions":"styles_questions__vCtxz","footer":"styles_footer__34c-b"};